import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './components/layout/header/header.component';
import {FooterComponent} from './components/layout/footer/footer.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {HtpInterceptor} from './shared/services/interceptor.service';
import {GlobalService} from './shared/services/global.service';
import {AlertService} from './shared/services/alert.service';
import {SnotifyModule, SnotifyService, ToastDefaults} from 'ng-snotify';
import {HomeComponent} from './components/pages/home/home.component';
import {NO_ERRORS_SCHEMA} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {IqacComponent} from './components/pages/iqac/iqac.component';
import {LightboxModule} from 'ngx-lightbox';
import {BlogComponent} from './components/pages/blog/blog.component';
import {BlogDetailComponent} from './components/pages/blog-detail/blog-detail.component';
import {PrivacyPolicyComponent} from './components/pages/privacy-policy/privacy-policy.component';
import {TermsAndConditionsComponent} from './components/pages/terms-and-conditions/terms-and-conditions.component';
import {HeaderProgramsModule} from "./components/pages/header-programs/header-programs.module";
import {AarniSchoolsModule} from "./components/pages/aarni-schools/aarni-schools.module";
import {AboutModule} from "./components/pages/about/about.module";
import {QuickLinksModule} from "./components/pages/quick-links/quick-links.module";
import {AdmissionsModule} from "./components/pages/admissions/admissions.module";
import {ResearchModule} from "./components/pages/research/research.module";
import {AcademicInfoModule} from "./components/pages/academic-info/academic-info.module";
import {ExamResultComponent} from "./components/pages/academic-info/exam-result/exam-result.component";
import {CampusLifeModule} from "./components/pages/campus-life/campus-life.module";
import {WhatsHappeningModule} from "./components/pages/whats-happening/whats-happening.module";
import {AlumniConnectModule} from "./components/pages/alumni-connect/alumni-connect.module";
import {
    InternationalAdmissionsModule
} from "./components/pages/international-admissions/international-admissions.module";
import { ItServiceComponent } from './components/pages/campus-life/it-service/it-service.component';
import {DownloadsModule} from "./components/pages/downloads/downloads.module";
import {SharedModule} from "./shared/shared.module";
import { DisclaimerComponent } from './components/pages/disclaimer/disclaimer.component';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        IqacComponent,
        BlogComponent,
        BlogDetailComponent,
        PrivacyPolicyComponent,
        TermsAndConditionsComponent,
        ExamResultComponent,
        ItServiceComponent,
        DisclaimerComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        SnotifyModule,
        FormsModule,
        BrowserAnimationsModule,
        LightboxModule,
        HeaderProgramsModule,
        AarniSchoolsModule,
        AboutModule,
        QuickLinksModule,
        AdmissionsModule,
        ResearchModule,
        AcademicInfoModule,
        CampusLifeModule,
        WhatsHappeningModule,
        AlumniConnectModule,
        DownloadsModule,
        InternationalAdmissionsModule,
        SharedModule,

    ],
    providers: [HtpInterceptor,
        GlobalService,
        AlertService,
        {provide: 'SnotifyToastConfig', useValue: ToastDefaults},
        SnotifyService],
    exports: [
    ],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {
}
